import React, { useEffect, useRef, useState } from 'react'
import { useOrderStore } from 'src/hooks/order';
import System from "../../../../helper/system";
import infoIcon from 'src/assets/images/info.svg';
import OrderHistoryDateFilter from '../Filters/OrderHistoryDateFilter';
import OrderHistorySearchFilter from '../Filters/OrderHistorySearchFilter';
import useReduxState from 'src/hooks/useReduxState';
import Helper from 'src/helper/Helper';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import $ from 'jquery';
import Constants from 'src/helper/Constants';
import { useObjCommonFilterStore } from 'src/hooks/objCommonFilter';
import moment from "moment";
import PaginationNextPrev from 'src/component/Global/PaginationNextPrev';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import Order from "@system/config/order";
import { Tooltip } from 'src/component/Global/Tooltip';
import store from "src/storeWire";
import { setOrderParams } from "src/store/slice/model/Order";
import { useSystem } from "src/hooks/system";

const OrderHistoryListing = (props) => {
    const [__check] = useAxiosIndicatorCheck();

    const [{ order_list, order_item_list }, { fetch_order_list, fetch_order_export_count, get_order_item_list }, { export_order, order_download_invoice }] = useOrderStore();
    const [{ filter_list }, { }, { }] = useObjCommonFilterStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [expandedRow, setExpandedRowT] = useState([])
    const [monitorFunctionCall, setMonitorFunctionCall] = useState({
            monitorJs: false,
            frameworkReady: false
          })
    const [filterOrderStatus] = useReduxState('', 'setFilterOrderStatus');
    const [dateRange] = useReduxState('', 'setDateRange');
    const [continuationToken, setContinuationToken] = useReduxState('', 'setContinuationToken');
    const [pageChange, setPageChange] = useState(false)
    const [pageTokens, setPageTokens] = useState([]);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [orderItemListState, setOrderItemListState] = useState([]);
    const dropdownRef = useRef([]);
    const isAnyDropdownOpen = openDropdownIndex !== null;
    const [,{ get_quantity_format }] = useSystem();
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 100,
        sortBy: '',
        sortOrder: '',
        ascDesField: {},
        total: 0
    })
    const { orderPayload: {
        orderNumber,
        poNumber,
        invoiceNo,
        trackingNo,
        releaseNo,
        orderType,
        orderStatus,
        manufacturerPartNumber,
        customerPartNumber,
        manufacturerName,
        deliveryDate,
        scheduleDate }, siteUser: { CORE }, currencyType: { USD }, downloadMsg } = Constants
    const { storageName: { ORDER_PAGE_COUNT, ORDER_PAGE_TOKEN }, avUserInfoData: { currentUser } } = System
    const isCoreUser = currentUser === CORE

    useEffect(() => {
        if (order_item_list && Object.entries(order_item_list).length > 0) {
            setOrderItemListState(prevOrderItemList => [
                ...prevOrderItemList,
                order_item_list
            ]);
        }
    }, [order_item_list])

    useEffect(() => {
        if (order_list.orderList?.length > 0 && order_list.totalOrderList) {
            setTimeout(() => {
                $(".floating-table").floatingScroll("init");
            }, 2500)
        }
    }, [order_list])

    useEffect(() => {
        const storedTokens = JSON.parse(localStorage.getItem(ORDER_PAGE_TOKEN)) || [];
        setPageTokens(storedTokens);
    }, []);

    useEffect(() => {
        const getList = async () => {
            const pageCount = await localStorage.getItem(ORDER_PAGE_COUNT)
            if (order_list.totalOrderList && order_list.totalOrderList > 0) {
                await localStorage.setItem(ORDER_PAGE_COUNT, order_list.totalOrderList)
                const total = order_list.totalOrderList;
                setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit), total: total })
            } else if (pageCount > 0 && order_list.totalOrderList <= 0) {
                const total = pageCount;
                await localStorage.setItem(ORDER_PAGE_COUNT, order_list?.orderList?.length === 0 ? 0 : pageCount)
                setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit), total: total })
            }

            if (order_list.orderList?.length > 0) {
                const manufacturerList = []
                order_list.orderList?.map((value) => {
                    if (value && value.manufacturerName) {
                        manufacturerList.push(value.manufacturerName)
                    }
                });
            }
        };
        getList();
    }, [order_list]);

    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 });
    }

    const handlePageClick = async (data) => {
        setPageChange(true);
        setOrderItemListState([])

        const nextPage = data.selected + 1;
        setListObj({ ...listObj, page: nextPage });

        const prevPageToken = continuationToken;
        if (!pageTokens.some(token => token.page === listObj.page + 1) && prevPageToken) {

            setPageTokens([...pageTokens, { page: listObj.page + 1, token: prevPageToken }]);
            localStorage.setItem(ORDER_PAGE_TOKEN, JSON.stringify([...pageTokens, { page: listObj.page + 1, token: prevPageToken }]));
        }

        Helper.scrollTop();
    };

    useEffect(() => {
        const getList = async () => {
            await fetchAPICall();
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit]);

    useEffect(() => {
        const getList = async () => {
            await fetchAPICall();
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.sortBy, listObj.sortOrder])

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
            setExpandedRowT([])
            localStorage.removeItem(ORDER_PAGE_TOKEN)
            setPageTokens([])
        };
        getList()
    }, [filter_list])

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };

        if (!(window.location.href.includes('orderNumber') && window.location.href.includes('POLineItemNumber'))) {
            getList()
        }
    }, [filterOrderStatus])

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };
        setExpandedRowT([])

        getList()
    }, [dateRange])

    const setDateForFilter = (dtObj) => {
        return moment(dtObj).local().format("YYYYMMDD");
    }

    const getReverseOrderType = (type) => {
        return type === "Offline" ? "OffLine" : "OnLine"
    }

    const fetchAPICall = async () => {
        let search_type = ''
        let search_keyword = ''
        const filter_option = []
        setOrderItemListState([])

        if (Object.entries(filter_list).length > 0) {
            Object.entries(filter_list).map(obj => {
                let tempObj
                if (obj[0] === orderNumber || obj[0] === poNumber || obj[0] === invoiceNo || obj[0] === trackingNo || obj[0] === releaseNo || obj[0] === orderType) {
                    search_type = obj[0]
                    search_keyword = obj[0] === orderType ? getReverseOrderType(obj[1]?.searchKeyword) : obj[1]?.searchKeyword
                } else if (obj[0] === deliveryDate || obj[0] === scheduleDate) {
                    tempObj = {
                        propertyName: obj[0],
                        from: setDateForFilter(obj[1]?.searchKeyword.split('-')[0]),
                        to: setDateForFilter(obj[1]?.searchKeyword.split('-')[1])
                    }
                } else {
                    tempObj = {
                        propertyName: obj[0],
                        propertyValue: obj[0] === orderStatus ? (obj[1]?.searchKeywordArr?.map((e) => e.value?.replace(/ /g, ""))).join(",") : obj[1]?.searchKeyword
                    }
                }
                if (tempObj) {
                    filter_option.push(tempObj)
                }
            })
        }

        if (dateRange) {
            const tempObj = {
                propertyName: 'orderDate',
                from: dateRange.split(';')[0],
                to: dateRange.split(';')[1]
            }
            filter_option.push(tempObj)
        }

        const token = pageTokens?.find(token => token?.page === listObj?.page);

        const params = {
            "keyword": search_keyword,
            "searchType": search_type,
            "continuationToken": pageChange ? token ? token.token : listObj?.page === 1 ? '' : continuationToken : '',
            "pageSize": Number(listObj.limit), //&& (((Number(limit) * (page - 1) + (Number(limit)))))
            "sortBy": listObj.sortBy ? listObj.sortBy : 'orderDate',
            "sortOrder": listObj.sortOrder ? listObj.sortOrder : 'desc',
            "filterByOption": filter_option,
        }

        store.dispatch(setOrderParams(params))

        if (dateRange) {
            const result = await fetch_order_list(params)
            setPageChange(false)
            if (!monitorFunctionCall?.frameworkReady || !monitorFunctionCall?.monitorJs) {
                System.monitorFrameWorkReady()
                System.monitorJSDx()
                setMonitorFunctionCall({...monitorFunctionCall, frameworkReady: true, monitorJs: true })
              }
            if (result?.payload?.totalOrderList === 0) {
                await fetch_order_export_count()
            }
            if (result?.payload?.continuationToken) {
                await setContinuationToken(result?.payload?.continuationToken)
            } else {
                await setContinuationToken(null)
            }
            await setFirstServerCall(false);
        }
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC';
        } else {
            listObj.ascDesField[columnName] = 'ASC'
        }
        localStorage.removeItem(ORDER_PAGE_TOKEN)
        setPageTokens([])
        setListObj({ ...listObj, sortBy: columnName, sortOrder: listObj.ascDesField[columnName], ascDesField: listObj.ascDesField, page: 1 })
    };

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if (firstServerCall === false && !monitorFunctionCall) {
            System.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [order_list.orderList])

    const handleRowClick = async (orderNumber) => {
        let filterOption = []
        if (Object.entries(filter_list).length > 0) {
            Object.entries(filter_list).map(obj => {
                let tempObj

                if (obj[0] === manufacturerPartNumber ||
                    obj[0] === customerPartNumber ||
                    obj[0] === manufacturerName) {
                    tempObj = {
                        propertyName: obj[0],
                        propertyValue: obj[1]?.searchKeyword
                    }
                } else if (obj[0] === deliveryDate || obj[0] === scheduleDate) {
                    tempObj = {
                        propertyName: obj[0],
                        from: setDateForFilter(obj[1]?.searchKeyword.split('-')[0]),
                        to: setDateForFilter(obj[1]?.searchKeyword.split('-')[1])
                    }
                }
                if (tempObj) {
                    filterOption.push(tempObj)
                }
            })
        }

        const payload = {
            "id": orderNumber,
            "filterByOption": filterOption,
        }

        if (!expandedRow.includes(orderNumber)) {
            try {
                await get_order_item_list(payload);
            } catch (error) {
                console.error('Error fetching order items:', error);
            }
        } else {
            setOrderItemListState(prevOrderItemList =>
                prevOrderItemList?.filter(item => !item.hasOwnProperty(orderNumber)) // Keep items that do not have the key
            );
        }

        setExpandedRowT(prevExpandedRow => {
            if (prevExpandedRow.includes(orderNumber)) {
                return prevExpandedRow.filter(row => row !== orderNumber);
            } else {
                return [...prevExpandedRow, orderNumber];
            }
        });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current) {
                const isInsideDropdown = dropdownRef.current.some(dropdown => dropdown && dropdown.contains(event.target));
                if (!isInsideDropdown) {
                    setOpenDropdownIndex(null);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {

        let isDisplayFixedHeader = false;
        let refreshStockButton;
        let callback;
        const list = order_list?.orderList
        if (list && Object.keys(list).length > 0) {
            const sort = toggleOrderBy;
            // table elelment with unique id
            const tableElement = document?.getElementById("orderhistory-table");
            // headerHeght contains height where we need to display static header
            //local
            // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            //sbx
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 65 + 1;
            // is used to track only one header will display at a moment

            // Admin Toolbar header height adjustment
            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }

            document.addEventListener("scroll", (ScrollEvent) => {
                // current table position from top
                const tablePosition = tableElement ? tableElement?.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect().y : false;
                if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    // function used to display header clone after actual header height is less than headerHeight from top
                    // function(id, headerHeight,  tableContainerId, noOfColummFixed, sort)
                    callback = stickyTableHeader("orderhistory-table", headerHeight, "sticky-table-wrapper", 3, sort)
                    // fixed header display now on ui
                    isDisplayFixedHeader = true
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        // switch variable to false for track that clone header hide
                        isDisplayFixedHeader = false;
                        // function used to remove the clone header
                        if (Object.prototype.toString.call(callback) === '[object Function]') {
                            callback();
                        }
                    }
                }
            })
        }
        return () => {
            if (callback) {
                // switch variable to false for track that clone header hide
                isDisplayFixedHeader = false;
                // check element exist before remove event listeners
                if (refreshStockButton && refreshStockButton[1]) {
                    refreshStockButton[1]?.removeEventListener("click", refreshStock);
                }
                // function used to remove the clone header
                callback();
            }
        }

    }, [order_list.orderList, __check(['ORDER_API_CALL']).status]);

    const downloadInvoice = async (invoiceNumber) => {
        const result = await order_download_invoice(invoiceNumber);
        if (result?.isSuccessfull) {
            system_alert_indicator({
                name: 'DownloadOrder',
                message: downloadMsg,
                type: "success"
            })
        } else {
            system_alert_indicator({
                name: 'DownloadOrder',
                message: 'Unable to download the document.',
                type: "danger"
            })
        }
    }

    const exportOrder = async (orderNumber, webOrderNumber) => {
        await export_order({
            orderNumber: orderNumber,
            webOrderNumber: webOrderNumber
        })
        system_alert_indicator({
            name: 'ExportOrder',
            message: "The document successfully downloaded.",
            type: "success"
        })
    }

    const getOrderType = (type) => {
        return type === "OffLine" ? "Offline" : "Online"
    }

    const getOrderStatus = (type) => {
        if (type === 'OrderReceived') {
            return 'Order Received'
        } else if (type === 'OrderInProcess') {
            return 'Order In Process'
        } else if (type === 'PartiallyShipped') {
            return 'Partially Shipped'
        } else {
            return type
        }
    }

    const renderKeyLegendTooltip = () => {
        return (
            <>
                ORDER RECEIVED: <br /> Order has been received but has not yet been processed. <br /><br />
                ORDER IN PROCESS: <br /> Order has been received and is currently in process. <br /><br />
                PARTIALLY SHIPPED:  <br /> Some of the items in order have been shipped. <br /><br />
                SHIPPED:  <br /> All items have been shipped. <br /><br />
                CANCELLED:  <br /> Order is cancelled.
            </>
        )
    }

    const toggleDropdown = (index) => {
        setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    };

    const navigateToOrderDetail = (orderNumber, webOrderNumber) => {
        const orderDetails = {
            order_number: orderNumber,
        };

        if (webOrderNumber) {
            orderDetails.web_order_number = webOrderNumber;
        }

        window.location.href = Order.getOrderDetailRouteURL(orderDetails);
    }

    return (
        <>
            <OrderHistoryDateFilter />
            {!firstServerCall && <OrderHistorySearchFilter />}
            {(__check('ORDER_API_CALL').status || order_list.orderList?.length > 0) &&
                <div className='position-relative'>
                    <div>
                        {__check(['ORDER_API_CALL'], { overlay: true }).render}
                    </div>
                    {
                        <div id="sticky-table-wrapper" className={`table-responsive m-t-15 floating-table sticky-table-wrapper ${isAnyDropdownOpen ? 'orderhistory-table-sticky' : ''}`}>
                            <table id="orderhistory-table" className="bs5 table table-bordered">
                                <thead>
                                    <tr>
                                        <th className='w155'></th>
                                        <th className='minw190'><span>P.O. Number</span>
                                            <span aria-label="poNumber" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('poNumber'))
                                            }
                                                onClick={async () => {
                                                    await toggleOrderBy('poNumber')
                                                }}></span>
                                        </th>
                                        <th className='minw140'><span>Order Number</span>
                                            <span aria-label="orderNumber" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('orderNumber'))
                                            }
                                                onClick={async () => {
                                                    await toggleOrderBy('orderNumber')
                                                }}></span>
                                        </th>
                                        <th className='minw140'>
                                            Order Status

                                            <Tooltip
                                                position={'bottom center'}
                                                opener={() => (
                                                    <a className="customer-link" href={void (0)}><i className='ms-2'><img className="" src={infoIcon} alt='Information' /></i><span
                                                        className="bs5 text-blue"></span></a>
                                                )}
                                                content={() => (
                                                    renderKeyLegendTooltip()
                                                )}
                                            />
                                            <span aria-label="orderStatus" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('orderStatus'))}
                                                onClick={async () => {
                                                    await toggleOrderBy('orderStatus')
                                                }}></span>
                                        </th>
                                        <th className='minw120'>
                                            Order Total Price
                                            <span aria-label="orderTotalWithTax" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('orderTotalWithTax'))}
                                                onClick={async () => {
                                                    await toggleOrderBy('orderTotalWithTax')
                                                }}></span>
                                        </th>
                                        <th className='minw120'>
                                            Order Date
                                            <span aria-label="orderDate" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('orderDate'))}
                                                onClick={async () => {
                                                    await toggleOrderBy('orderDate')
                                                }}></span>
                                        </th>
                                        {isCoreUser &&
                                            <>
                                                <th className='minw120'>
                                                    Account Number
                                                    <span aria-label="accountNo" aria-pressed="false" className={'sort-container ' +
                                                        (getOrderByClass('accountNo'))}
                                                        onClick={async () => {
                                                            await toggleOrderBy('accountNo')
                                                        }}></span>
                                                </th>
                                                <th className='minw120'>
                                                    Buyer
                                                    <span aria-label="buyerName" aria-pressed="false" className={'sort-container ' +
                                                        (getOrderByClass('buyerName'))}
                                                        onClick={async () => {
                                                            await toggleOrderBy('buyerName')
                                                        }}></span>
                                                </th>
                                            </>}
                                        <th className='minw120'>
                                            Release Number
                                            <span aria-label="ReleaseNumber" aria-pressed="false"></span>
                                        </th>
                                        <th className='minw120'>
                                            Tracking/WayBill Number
                                            <span aria-label="TrackingNumber" aria-pressed="false"></span>
                                        </th>
                                        <th className='minw120'>
                                            Invoice Number
                                            <span aria-label="InvoiceNumber" aria-pressed="false"></span>
                                        </th>
                                        <th><span>Order Type</span>
                                            <span aria-label="orderType" aria-pressed="false" className={'sort-container ' +
                                                getOrderByClass('orderType')
                                            }
                                                onClick={async () => {
                                                    await toggleOrderBy('orderType')
                                                }}></span>
                                        </th>
                                    </tr>
                                </thead>
                                {order_list.orderList?.length > 0 &&
                                    <tbody>
                                        {order_list.orderList?.map((v, i) => (
                                            <React.Fragment key={i}>
                                                <tr className={expandedRow?.length > 0 && expandedRow.includes(v.orderNumber ? v.orderNumber : v.webOrderNumber) ? 'align-middle bg-offwhite' : 'align-middle'}>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <div className="accordion-white-button">
                                                                <div className="accordian-arrow">
                                                                    <i
                                                                        className={expandedRow.includes(v.orderNumber ? v.orderNumber : v.webOrderNumber) ? 'fa fa-angle-double-up me-0 d-block' : 'fa fa-angle-double-down me-0 d-block'}

                                                                        onClick={() => handleRowClick(v.orderNumber ? v.orderNumber : v.webOrderNumber)}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div ref={el => dropdownRef.current[i] = el} className={`dropdown selectbox w110 ms-3 ${openDropdownIndex === i ? 'open' : ''}`}>
                                                                <a
                                                                    className="bs5 form-control form-control-sm text-black dropdown-control"
                                                                    onClick={() => toggleDropdown(i)}
                                                                    aria-expanded={openDropdownIndex === i}
                                                                >
                                                                    <span>Options</span>
                                                                </a>
                                                                {openDropdownIndex === i && (
                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                        <li>
                                                                            <a
                                                                                href={void (0)}
                                                                                className="dropdown-item text-black"
                                                                                onClick={() => navigateToOrderDetail(v.orderNumber, v.webOrderNumber)}
                                                                            >
                                                                                <i className='fa fa-eye'></i>
                                                                                View Order Details
                                                                            </a>
                                                                        </li>
                                                                        <li>
                                                                            <a
                                                                                href={void (0)}
                                                                                className="dropdown-item text-black d-flex align-items-center"
                                                                                onClick={() => exportOrder(v?.orderNumber, v?.webOrderNumber)}
                                                                            >
                                                                                <i className="order-export-icon text-black-stone" aria-hidden="true"></i>
                                                                                Export This Order
                                                                            </a>
                                                                        </li>
                                                                        {v.invoiceNo?.length > 0 && v.orderStatus === 'Shipped' && (
                                                                            <li>
                                                                                <a
                                                                                    href={void (0)}
                                                                                    className="dropdown-item text-black"
                                                                                    onClick={() => downloadInvoice(v.invoiceNo)}
                                                                                >
                                                                                    <i className="fa fa-download"></i>
                                                                                    Download All Invoices
                                                                                </a>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td><div className="d-block"><span className='text-blue cursor-pointer' onClick={() => navigateToOrderDetail(v.orderNumber, v.webOrderNumber)}>{v.poNumber ? v.poNumber : ''}</span></div>
                                                    </td>
                                                    <td>
                                                        <div className="d-block">Web#: {v.webOrderNumber ? <span className='text-blue cursor-pointer' onClick={() => navigateToOrderDetail(v.orderNumber, v.webOrderNumber)}>{v.webOrderNumber}</span> : '-'}</div>

                                                        <div className="d-block">Sales#: <span className='text-blue cursor-pointer' onClick={() => navigateToOrderDetail(v.orderNumber, v.webOrderNumber)}>{v.orderNumber ? v.orderNumber : '-'}</span> </div>
                                                    </td>
                                                    <td>{v.orderStatus ? getOrderStatus(v.orderStatus) : ''}</td>
                                                    <td>{v.orderTotalWithTax ? System.getFormatNumber({ amount: Number(v.orderTotalWithTax), currency: USD }) : ''}</td>
                                                    <td>{v.orderDate ? Helper.convertOrderModuleDateFormat(v.orderDate) : ''}</td>
                                                    {isCoreUser &&
                                                        <>
                                                            <td>{v.accountNo ? v.accountNo : ''}</td>
                                                            <td>{v.buyerName ? v.buyerName : ''}</td>
                                                        </>}
                                                    <td>{v.releaseNo ? v.releaseNo?.length > 2 ?
                                                        <a onClick={() => System.popup('OrderReleasesPopup', { releaseNo: v.releaseNo, poNumber: v.poNumber })}>View all Releases</a> :
                                                        v.releaseNo.join('\n').split('\n').map((value, index) => (
                                                            <div key={index}>{value}</div>
                                                        )) : ''}</td>
                                                    <td>{v?.trackingDetails ? v?.trackingDetails?.length > 2 ?
                                                        <a onClick={() => System.popup('OrderDetailViewAllTrackingPopup', { trackingDetails: v.trackingDetails, poNumber: v.poNumber })}>View all Tracking</a> :
                                                        v.trackingDetails.map((value, index) => (
                                                            <div key={index}>
                                                                {value.trackingUrl ?
                                                                    <a href={value.trackingUrl} target='_blank'><span className='text-blue'>{value?.trackingNo}</span></a> :
                                                                    <span className='text-black'>{value?.trackingNo}</span>}
                                                            </div>
                                                        )) : ''}</td>
                                                    <td>{v.invoiceNo ? v.invoiceNo?.length > 2 ?
                                                        <a onClick={() => {
                                                            System.popup('OrderDetailViewInvoicesPopup', {
                                                                invoiceData: v.invoiceNo,
                                                                poNumber: v.poNumber
                                                            })
                                                        }}>View all Invoices</a> :
                                                        v.invoiceNo.join('\n').split('\n').map((value, index) => (
                                                            <div key={index} className="mb-2">
                                                                <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                                    onClick={() => downloadInvoice([value])}>{value && <i className='fa fa-download me-2 text-black'></i>}{value} </a>
                                                                <input type="hidden" id="invoiceUrlGeneration1" />
                                                            </div>
                                                        )) : ''}</td>
                                                    <td>{v.orderType ? getOrderType(v.orderType) : ''}</td>
                                                </tr>
                                                <tr className='align-middle bg-offwhite'>
                                                    <td colSpan={19} className='p-0'>
                                                        <div className={expandedRow?.includes(v.orderNumber ? v.orderNumber : v.webOrderNumber) ? "table-responsive mb-0" : "table-responsive mb-0 d-none"}>
                                                            <table className="bs5 table table-head-border-x-0 mb-4">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="w40 border-0 bg-offwhite"></th>
                                                                        {isCoreUser && <th className="w85"></th>}
                                                                        <th className="w100"><span>Line Item <br />Number</span></th>
                                                                        <th className=""><span>Manufacturer</span></th>
                                                                        <th className=""><span>Manufacturer <br /> Part Number</span></th>
                                                                        {isCoreUser && <th className=""><span>Customer Part <br />Number</span></th>}
                                                                        <th className=""><span>Line Status</span></th>
                                                                        <th className=""><span>Ordered <br />Quantity</span></th>
                                                                        <th className=""><span>Unit Price</span></th>
                                                                        <th className=""><span>Total Price</span></th>
                                                                        <th className=""><span>Total Price <br />With Tax</span></th>
                                                                        <th className=""><span>Total Shipped <br />Quantity</span></th>
                                                                        <th className=""><span>Total Remaining <br />Quantity</span></th>
                                                                        {isCoreUser && <th className=""><span>Customer <br />Requested Date</span></th>}
                                                                        <th className=""><span>Expected <br />Delivery Date</span></th>
                                                                    </tr>
                                                                </thead>
                                                                {orderItemListState && orderItemListState?.length > 0 &&
                                                                    <>
                                                                        <tbody>
                                                                            {orderItemListState?.map((data) => {
                                                                                const items = data[v.orderNumber || v.webOrderNumber];
                                                                                return items ? items.map((val, i) => (
                                                                                    <tr className="align-middle" key={i}>
                                                                                        <td className='border-0'></td>
                                                                                        {isCoreUser && (
                                                                                            <td>
                                                                                                <div>
                                                                                                    <a
                                                                                                        href={void (0)}
                                                                                                        onClick={() => System.popup('OrderHistoryEmailPopUp', {
                                                                                                            singleOrder: { ...v, salesOrderNumber: orderNumber },
                                                                                                            singleProduct: val
                                                                                                        })}
                                                                                                        className="text-blue2 d-flex align-items-center"
                                                                                                        data-toggle="modal"
                                                                                                        data-target="#EmailMessage"
                                                                                                    >
                                                                                                        <i className="fa fa-envelope font-16 me-2"></i>
                                                                                                    </a>
                                                                                                </div>
                                                                                            </td>
                                                                                        )}
                                                                                        <td><div>{val.orderItemNumber}</div></td>
                                                                                        <td><span className="text-nowrap">{val.parentManufacturerName || ''}</span></td>
                                                                                        <td>
                                                                                            {val.itemNo && val.manufacturerPartNumber ? (
                                                                                                <NavigateToProductDetail target="_blank" data={{SEOManufacturerName: val.seoManufacturerName, SEOERPMFRPartNumber: val.seoerpmfrPartNumber, ItemNumber: val.itemNo, ERPPartNumber: val.sapMaterial }}>
                                                                                                    <span className="text-nowrap text-blue2">{val.manufacturerPartNumber || ''}</span>
                                                                                                </NavigateToProductDetail>
                                                                                            ) : (
                                                                                                <span className="text-nowrap">{val.manufacturerPartNumber || ''}</span>
                                                                                            )}
                                                                                        </td>
                                                                                        {isCoreUser && <td><span className="text-nowrap">{val.customerPartNumber || ''}</span></td>}
                                                                                        <td><span className="text-nowrap">{val.orderStatus ? getOrderStatus(val.orderStatus) : ''}</span></td>
                                                                                        <td><span className="text-nowrap">{get_quantity_format(Number(val.quantity))}</span></td>
                                                                                        <td><span className="text-nowrap">{val.unitPrice ? System.getFormatNumber({ amount: Number(val.unitPrice), currency: USD }) : ''}</span></td>
                                                                                        <td><span className="text-nowrap">{val.totalLinePrice ? System.getFormatNumber({ amount: Number(val.totalLinePrice), currency: USD, maximumFractionDigits: 2 }) : ''}</span></td>
                                                                                        <td><span className="text-nowrap">{val.totalWithTax ? System.getFormatNumber({ amount: Number(val.totalWithTax), currency: USD, maximumFractionDigits: 2 }) : ''}</span></td>
                                                                                        <td><span className="text-nowrap">{get_quantity_format(Number(val.totalShippedQty))}</span></td>
                                                                                        <td><span className="text-nowrap">{get_quantity_format(Number(val.totalRemainingQty))}</span></td>
                                                                                        {isCoreUser && <td><span className="text-nowrap">{val.scheduleDate ? Helper.convertOrderModuleDateFormat(val.scheduleDate) : ''}</span></td>}
                                                                                        <td><span className="text-nowrap">{val.deliveryDate ? Helper.convertOrderModuleDateFormat(val.deliveryDate) : ''}</span></td>
                                                                                    </tr>
                                                                                )) : [];
                                                                            })}
                                                                        </tbody>
                                                                    </>}
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ React.Fragment>
                                        ))}
                                    </tbody>
                                }
                            </table>
                        </div>
                    }
                    {order_list.orderList && order_list.orderList?.length > 0 &&
                        <PaginationNextPrev pageCount={listObj.pageCount} handlePageClick={handlePageClick} page={listObj.page - 1} limit={listObj.limit} total={listObj.total} />
                    }
                </div>
            }

            {
                !__check(['ORDER_API_CALL']).status && (Object.keys(order_list).length === 0 || order_list.orderList === undefined || order_list.orderList?.length === 0) && dateRange &&

                <div className='container'>
                    <div className='mb-3 d-flex justify-content-center'>
                        <div className='alert alert-info d-flex justify-content-center mt-3' role="alert">
                            <span>Sorry! No Result Found. We can't find any results based on your selection.</span>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default OrderHistoryListing